import React, { useState, useEffect } from 'react';
import { Form, Button, ListGroup, Badge } from 'react-bootstrap';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Header from '../components/Header';
import { Link } from 'react-router-dom';

const Info = withReactContent(Swal);

const diagnosisSuggestions = {
    'Střelné zranění': [
        'Průstřel dolní končetiny',
        'Průstřel horní končetiny',
        'Střelná rána v oblasti hrudníku',
        'Střelná rána v oblasti břicha',
        'Masivní krvácení',
        'Bolest v oblasti střelné rány',
        'Porucha vědomí',
        'Zástava dechu',
        'Nestabilní tlak',
        'Ztráta orientace',
        'Šokový stav'
    ],
    'Dopravní nehoda': [
        'Otřes mozku',
        'Fraktura pravé ruky',
        'Fraktura dolní končetiny',
        'Bolest krční páteře',
        'Zlomenina žeber',
        'Polytrauma',
        'Bezvědomí',
        'Masivní krvácení z dolní končetiny',
        'Poranění páteře',
        'Poranění vnitřních orgánů',
        'Záchvat paniky'
    ],
    'Asistence PD': [
        'Zajištění pacienta po zákroku PD',
        'Transport z výslechu',
        'Ošetření zranění způsobené pouty',
        'Zajištění po střetu s podezřelým',
        'Kontrola vitálních funkcí zadrženého',
        'Psychická nestabilita po zásahu',
        'Následky fyzického zákroku',
        'Zajištění převozu na lékařské vyšetření'
    ],
    'Úmrtí (CK)': [
        'Konstatováno úmrtí na místě',
        'Zajištění těla k převozu',
        'Identifikace zesnulého',
        'Smrt následkem střelného poranění',
        'Smrt následkem dopravní nehody',
        'Smrt při služebním zákroku',
        'Tělo bez známek života',
        'Přítomnost zástavy životních funkcí',
        'Bezvědomí nereagující na podněty'
    ],
    'Jiné': [
        'Zásah mimo běžný rozsah',
        'Spolupráce s civilní složkou',
        'Ošetření bez nutnosti převozu',
        'Dehydratace a vyčerpání',
        'Záchvat paniky',
        'Psychické zhroucení pacienta',
        'Nevolnost a mdloby',
        'Podchlazení',
        'Vysoký krevní tlak'
    ]
};


const NewRecord = () => {
    const [form, setForm] = useState({
        lokalita: '',
        kolegove: '',
        pacient: '',
        popis: '',
        typ: 'Střelné zranění',
        user: '',
        dcuser: ''
    });
    const [btn, setBtn] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [allPatients, setAllPatients] = useState([]);
    const [allLocations, setAllLocations] = useState([]);
    const [lokalitaSuggestions, setLokalitaSuggestions] = useState([]);
    const [validUsers, setValidUsers] = useState([]);
    const [userSuggestions, setUserSuggestions] = useState([]);

    useEffect(() => {
        const raw = localStorage.getItem('ems_member');
        if (raw) {
            const parsed = JSON.parse(raw);
            setForm(prev => ({ ...prev, user: parsed.user.nickname, dcuser: parsed.user.username }));
        }

        fetch('https://ems.lexikonn.eu/api/pacient_names.php')
            .then(res => res.json())
            .then(setAllPatients);

        fetch('/data/gta_locations.json')
            .then(res => res.json())
            .then(setAllLocations);

        fetch('https://ems.lexikonn.eu/api/get_records.php')
            .then(res => res.json())
            .then(data => {
                const uniqueUsers = Array.from(new Set(data.map(r => r.user).filter(Boolean)));
                setValidUsers(uniqueUsers);
            });
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });

        if (name === 'pacient') {
            const filtered = allPatients.filter(p =>
                p.toLowerCase().includes(value.toLowerCase()) && value.length > 1
            );
            setSuggestions(filtered);
        }

        if (name === 'lokalita') {
            const filtered = allLocations.filter(l =>
                l.toLowerCase().includes(value.toLowerCase()) && value.length > 1
            );
            setLokalitaSuggestions(filtered);
        }

        if (name === 'kolegove') {
            const inputParts = value.split(',').map(p => p.trim());
            const lastPart = inputParts[inputParts.length - 1].toLowerCase();

            const filtered = validUsers.filter(user =>
                user.toLowerCase().includes(lastPart) && lastPart.length > 0
            );
            setUserSuggestions(filtered);
        }
    };

    const handleSuggestionClick = (name) => {
        setForm({ ...form, pacient: name });
        setSuggestions([]);
    };

    const handleLokalitaClick = (lok) => {
        setForm({ ...form, lokalita: lok });
        setLokalitaSuggestions([]);
    };

    const handleMembersClick = (selectedName) => {
        if (!selectedName) return;

        let current = form.kolegove.trim();
        let parts = current.split(',').map(p => p.trim()).filter(Boolean);

        if (parts.length > 0 && !current.endsWith(',')) {
            parts[parts.length - 1] = selectedName;
        }
        else {
            parts.push(selectedName);
        }

        const uniqueParts = [...new Set(parts)];
        setForm({ ...form, kolegove: uniqueParts.join(', ') });
        setUserSuggestions([]);
    };



    const handleDiagnosisClick = (text) => {
        setForm(prev => ({ ...prev, popis: prev.popis ? `${prev.popis}\n${text}` : text }));
    };

    const handleSubmit = (e) => {
        setBtn(true);
        e.preventDefault();
        fetch('https://ems.lexikonn.eu/api/newrecord.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(form),
        })
            .then(res => res.json())
            .then((data) => {
                if (data.success) {
                    Info.fire({
                        icon: 'success',
                        title: 'Uloženo',
                        text: 'Záznam o výjezdu byl uložen!',
                        showDenyButton: true,
                        confirmButtonText: 'Zavřít',
                        denyButtonText: 'Duplikovat'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            window.location.reload();
                        }
                    });
                } else {
                    Info.fire({ icon: 'error', title: 'Chyba', text: data.message || 'Záznam nebyl uložen' });
                }
                setBtn(false);
            });
    };

    return (
        <div className="container py-5">
            <Link to="/" className="btn btn-secondary mb-3">Zpět</Link>
            <Header />
            <div className="box">
                <h2>Zápis výjezdu</h2>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3 position-relative">
                        <Form.Label>Lokalita</Form.Label>
                        <Form.Control
                            type="text"
                            name="lokalita"
                            value={form.lokalita}
                            onChange={handleChange}
                            autoComplete="off"
                            placeholder="např. Vinewood Hills"
                        />
                        {lokalitaSuggestions.length > 0 && (
                            <ListGroup className="position-absolute w-100 z-3" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                {lokalitaSuggestions.map((s, i) => (
                                    <ListGroup.Item key={i} action onClick={() => handleLokalitaClick(s)}>
                                        {s}
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        )}
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Kolegové (oddělit čárkou)</Form.Label>
                        <Form.Control
                            type="text"
                            name="kolegove"
                            value={form.kolegove}
                            onChange={handleChange}
                        />
                        {userSuggestions.length > 0 && (
                            <ListGroup className="position-absolute w-100 z-3" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                {userSuggestions.map((s, i) => (
                                    <ListGroup.Item key={i} action onClick={() => handleMembersClick(s)}>
                                        {s}
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        )}
                    </Form.Group>

                    <Form.Group className="mb-3 position-relative">
                        <Form.Label>Jméno pacienta</Form.Label>
                        <Form.Control
                            type="text"
                            name="pacient"
                            placeholder="např. John Doe"
                            value={form.pacient}
                            onChange={handleChange}
                            autoComplete="off"
                        />
                        {suggestions.length > 0 && (
                            <ListGroup className="position-absolute w-100 z-3" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                {suggestions.map((s, i) => (
                                    <ListGroup.Item key={i} action onClick={() => handleSuggestionClick(s)}>
                                        {s}
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        )}
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Typ zásahu</Form.Label>
                        <Form.Select name="typ" value={form.typ} onChange={handleChange}>
                            {Object.keys(diagnosisSuggestions).map((typ, index) => (
                                <option key={index} value={typ}>{typ}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    {diagnosisSuggestions[form.typ] && (
                        <div className="mb-3">
                            <Form.Label>Rychlý výběr diagnóz</Form.Label>
                            <div className="d-flex flex-wrap gap-2">
                                {diagnosisSuggestions[form.typ].map((d, idx) => (
                                    <Badge
                                        key={idx}
                                        bg="danger"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => handleDiagnosisClick(d)}
                                    >
                                        {d}
                                    </Badge>
                                ))}
                            </div>
                        </div>
                    )}

                    <Form.Group className="mb-3">
                        <Form.Label>Popis zásahu</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={5}
                            name="popis"
                            value={form.popis}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <Button disabled={btn} variant="danger" type="submit">
                        <i className="bi bi-save"></i> Uložit zásah
                    </Button>
                </Form>
            </div>
        </div>
    );
};

export default NewRecord;
